module.exports = __webpack_public_path__ + "img/guide_3_3.9dc7f511.svg";